<template>
      <fragment>
        <div :class="this.classValue" :data-label="Label ? labelCaption : null">
                <div class="input-group">
                    <input
                        :type="showPassword ? 'text' : 'password'"
                        :placeholder="Placeholder"
                         v-on:keyup.enter="onEnter"
                        :aria-describedby="Name"
                        v-bind:value="value"
                        v-on:keypress="$emit('keypress', $event)"
                        v-on:input="onInput"

                        v-mask="this.Mask"
                        :tabindex="this.TabIndex"
            :maxlength="MaxLengthProp"
            :readonly="isReadOnly"
            :min="Min"
            :max="Max"
            :step="StepProp"
            :ref="Name"
            :id="Id"
            class="form-control"
            :autocomplete="autocomplete"
            v-on:blur="onBlur"
            v-on:change="OnChange"
                      >


                     <div class="input-group-append">
                        <button
                            tabindex="-1"
                            @click="showPassword = !showPassword"
                            class="btn btn-sm search-attached-password"
                            type="button"
                             >
                          <b-icon-eye v-if="!showPassword"/>
                          <b-icon-eye-fill v-if="showPassword"/>
                        </button>
                    </div>
                    <!-- <b-form-invalid-feedback
                        :id="RefCode"
                    >{{ invalidFeedback }}</b-form-invalid-feedback> -->
                </div>
            </div>

     </fragment>
</template>

<script>
import Utils from '../../../common/utils'
import { EventBus } from '@/event-bus.js';
export default {
  name: 'MdPassword',
   props: {
     TypeProp:String,
     StepProp:String,
     MaxLengthProp: Number,
     isReadOnly:Boolean,
     Min:String,
     Max:String,
     isRequired:Boolean,
     value:[String, Number, Date],
     Name:String,
     Id:String,
     isValid:Boolean,
     Label:String,
     Placeholder:String,
     Autocomplete:Boolean,
     Mask: String,
     Tag: String,
     TabIndex:String,
     isEndControl:Boolean,
     EndControlFunction:Function,
     NoValidateChanges: Boolean,
    classValueStyle:String,
    classValueInvalidStyle:String
   },

   data(){
     return {
      Count:0,
      isEndControlLocal:this.isEndControl,
      showPassword: false,
      showPointer: false,
      classValue: this.classValueStyle ? this.classValueStyle : "textlabel",
      autocomplete:this.Autocomplete ? 'on' : 'off',
      invalidFeedback:""
     }
   },

   computed:{
    internalClassValueStyle(){
            return this.classValueStyle ? this.classValueStyle : "textlabel";
        },

        internalClassValueInvalidStyle(){
            return this.classValueInvalidStyle ? this.classValueInvalidStyle : "textlabel-invalid";
        },

      labelCaption() {
            return !this.isRequired ? this.Label+this.invalidFeedback : this.Label+' * '+this.invalidFeedback;
        },

        invalidFeedbackMessage() {
            if (Utils.isNullOrEmptyString(this.invalidMessage)) {
                if (this.isRequired) {
                    return this.$t('Msg.RequiredField');
                } else {
                    return '';
                }
            }

            return this.invalidMessage;
        },
   },

watch: {

  isValid: function (newValue) {
    this.classValue= newValue ? this.internalClassValueStyle : this.internalClassValueInvalidStyle;
    this.invalidFeedback = newValue ? "": ": "+this.invalidFeedbackMessage;
    },

    invalidMessage(newVal) {
        this.invalidFeedback = (Utils.isNullOrEmptyString(newVal) ? "" :  ": ") + this.invalidFeedbackMessage;
    }
  },

methods:{
    checkIsRequired(evt){
      let IsValid = false;
        if(this.isRequired){
            if(evt.target?.value?.trim() === ""){
                IsValid = false;
            }else{
                IsValid = true;
            }
        }else{
            IsValid = true;
        }
      this.classValue = IsValid ? this.internalClassValueStyle : this.internalClassValueInvalidStyle;
      this.$emit('isValidPassword', {IsValid:IsValid,Id:this.Name});

    },

    onEnter(){
      if(this.isEndControlLocal)
        this.EndControlFunction();
    },


    OnChange(evt){
       this.checkIsRequired(evt)
       this.$emit('change',evt.target.value)
     },

    onBlur(evt) {
      this.checkIsRequired(evt)
      this.$emit('blur', evt.target.value)
    },

    setFocus(){
       this.$refs[this.Name].focus();
    },

    onInput(evt){
      this.Count++;
     if(!this.Mask || this.Count > 1){
        this.$emit('input', evt.target.value)
      var changed = {
        "Changed":true,
        "ComponentName":this.Name,
        "Tag": this.Tag
      }
      if(!this.NoValidateChanges){
        EventBus.$emit('onChanged', changed);
      }
     }
    }
  }
};

</script>

<style>
 @import '../../../assets/css/Patients/Patient.css';
</style>


